import { V3Record } from 'data/helpers/V3Record.js'

export const PrivacyCode = V3Record('privacyCode', {
  parentType: null,
  parentId: null,
  code: null,
  scope: null
}, {
  writeable: []
})
